import { render, staticRenderFns } from "./WxCarselectPanel.vue?vue&type=template&id=e0f4226c&scoped=true&"
import script from "./WxCarselectPanel.vue?vue&type=script&lang=js&"
export * from "./WxCarselectPanel.vue?vue&type=script&lang=js&"
import style0 from "./WxCarselectPanel.vue?vue&type=style&index=0&id=e0f4226c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f4226c",
  null
  
)

export default component.exports